import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const customPracticeQueueCalendarRoute: InvariantJiraRoute = {
	name: 'servicedesk-queues-practice-custom-calendar',
	path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/calendar/:boardId',
	exact: true,
};
